module.exports = __webpack_public_path__ + "static/media/Pinsir_gaussian2.e65212ab.png";